module.exports = __webpack_public_path__ + "img/kyrgyzstan.eb2337cc.svg";